import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from "@angular/core";

import { FormControl, FormGroup } from "@angular/forms";
import { SelectMenuOption } from "../../../form/select-menu/select-menu.component";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { Observable } from "rxjs/Observable";
import { GeneralRowEvent } from "../../../_models/general-row-event";
import { DateRangeSelectComponent } from "../../../common/date-range-select/date-range-select.component";
import { EventsService } from "../../../_services/eventsServices/events.service";
import { DiscountManagementService } from "../../../_services/discount-management.service";
import { environment } from "../../../../environments/environment";
import { ChildAbstractModel } from "../../../_models/child-abstract-model";
import { ServerNamespace } from "../../../_models/server/server-namespace";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SelectOrgansComponent } from "../../../common/select-organs/select-organs.component";
import { SelectLayersComponent } from "../../../common/select-layers/select-layers.component";
import { ReceiptManagementService } from "../../../_services/receipt-management.service";
import { UserAbstractModel } from "../../../_models/user-abstract-model";

@Component({
  selector: "receipt-page-search",
  templateUrl: "./receipt-page-search.component.html",

  styleUrls: [
    "./receipt-page-search.component.scss",
    "../../payments/payments.component.scss",
  ],
})
export class ReceiptPageSearchComponent {
  @ViewChild("componentMain") public componentMain: ElementRef;

  @ViewChild("selectOrgansComponent")
  public selectOrgansComponent: SelectOrgansComponent;

  @ViewChild("selectLayersComponent")
  public selectLayersComponent: SelectLayersComponent;
  @ViewChild("dateRangePicker")
  public dateRangePicker: DateRangeSelectComponent;
  @Output("searchSectionEvent") public searchSectionEvent: EventEmitter<
    GeneralRowEvent<any>
  > = new EventEmitter<GeneralRowEvent<any>>();

  public advanceSearchForm = new FormGroup({
    limitToCurrentYear: new FormControl(true),
  });
  public yearsSelectMenuOptions: SelectMenuOption[] = [
    {
      icon: "",
      key: "thisYear",
      text: 'תשפ"ד',
      customValue: "",
    },
    {
      icon: "",
      key: "allYears",
      text: "כל השנים",
      customValue: "",
    },
  ];

  public translations$: Observable<ITranslations>;
  public selectedChild: ChildAbstractModel | null = null;
  public selectedIssuer: UserAbstractModel | null = null;
  public screenWidth: number;
  public formFieldLength: number = 300;
  public checksOrPartials: "onlyChecks" | "onlyPartialDeposits" | null = null;
  private selectedEvent: string | null = null;
  constructor(
    private modalService: NgbModal,
    private eventsService: EventsService,
    private translationService: TranslationService,
    private receiptManagementService: ReceiptManagementService
  ) {
    this.getCurrentYear().then();
    this.translations$ = this.translationService.translations;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth < 500) {
      this.formFieldLength = 300;
    }
  }

  public async getCurrentYear() {
    const shnatPeilut = await this.eventsService.getCurrentYear();
    if (shnatPeilut) {
      this.yearsSelectMenuOptions = this.yearsSelectMenuOptions.map((year) => {
        if (year.key === "thisYear") {
          return { ...year, text: shnatPeilut.value };
        }
        return year;
      });
    }
  }

  public customFilterAction(type: "onlyChecks" | "onlyPartialDeposits") {
    switch (type) {
      case "onlyChecks":
        this.checksOrPartials =
          this.checksOrPartials === "onlyChecks" ? null : "onlyChecks";

        break;
      case "onlyPartialDeposits":
        this.checksOrPartials =
          this.checksOrPartials === "onlyPartialDeposits"
            ? null
            : "onlyPartialDeposits";

        break;
    }
  }

  public submitAdvancedSearch() {
    const selectedNests = this.selectOrgansComponent.getSelectedOrgans() || [];
    const grades_ids =
      (this.selectLayersComponent &&
        this.selectLayersComponent.getSelectedLayers()) ||
      [];

    const kehilot = selectedNests
      .filter((k) => k.type === "circle")
      .map((k) => +k.id);
    const kenim = selectedNests
      .filter((k) => k.type === "nest")
      .map((k) => +k.id);
    const mehozot = selectedNests
      .filter((c) => c.type === "county")
      .map((k) => +k.id);
    const hanich_id =
      this.selectedChild && this.selectedChild.childId
        ? this.selectedChild.childId.toString()
        : null;
    const issuer_id =
      this.selectedIssuer && this.selectedIssuer.id
        ? this.selectedIssuer.id.toString()
        : null;

    const parent_event_id = this.selectedEvent;
    const checksOrPartials = () => {
      switch (this.checksOrPartials) {
        case "onlyChecks":
          return "cheque";
        case "onlyPartialDeposits":
          return "partial";
        default:
          return "all";
      }
    };

    this.receiptManagementService
      .searchReceipts({
        typeOfDeposits: checksOrPartials(),
        kehilot,
        kenim,
        mehozot,
        hanich_id,
        parent_event_id,
        grades_ids,
        issuer_id,
      } as any)
      .then();
  }
  public issuerSelectedEvent($event: UserAbstractModel | null) {
    this.selectedIssuer = $event;
  }
  public childSelectedEvent($event: ChildAbstractModel | null) {
    this.selectedChild = $event;
  }

  public eventSelectedEvent(
    $event: ServerNamespace.GetParentEventForSubsidySearch | null
  ) {
    this.selectedEvent = $event && $event.id.toString();
  }
}

export default ReceiptPageSearchComponent;



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-page-search/receipt-page-search.component.ts